module.exports = __webpack_public_path__ + "img/CertifiedNetPromoWeb.3485a0e0.jpg";